<template>
    <div>
       <div class="yg_nav">
		<!--导航条-->
            <!-- <div class="yg-l"> -->
                <!-- <span class="yg_nav1_1">活动管理</span> -->
                <!-- <div class="qiehuan"> -->
				 <!--切换条-->
<!--                    <ul>
                        <li class="sy"><a href="javascript:void(0)" @click="jump('hdshouye')">首页</a></li>
                        <li class="hd"><a href="javascript:void(0)" >活动设置</a></li>
                    </ul> -->
                <!-- </div> -->
				<!--切换条-->
            <!-- </div> -->
        </div>
        <div style="width: 100%;height: 2px;border-bottom: 1px solid #ecedff; "></div>
		<!--下边线 -->
        <!--导航条-->
        <form action="" id="formadd" method="post" enctype="multipart/form-data">
            <div class="zhuti">
                <div class="huod_t">活动添加</div>
                <div class="tjkuang" style="height: auto;padding-bottom: 10px">
                    <div class="hang2">
                        <div class="h2_l">
                            <div class="hang3">
                                <span class="span1">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>
                                <el-date-picker
                                        v-model="value1"
                                        type="date"
                                        name="start_time"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </div>
                            <div class="hang3">
                                <span class="span1"> 活动主题</span>
                                <input class="in1" type="text" name="title" v-model="title1" required>
                            </div>
<!--                            <div class="hang3">-->
<!--                                <span class="span1"> 活动类型</span>-->
<!--                                <input style="margin: 0;vertical-align: middle" value="G" name="system_flag" type="radio" checked>-->
<!--                                <span style="padding-right: 10px">早教       </span>-->
<!--                                <input style="margin: 0;vertical-align: middle" value="M" name="system_flag" type="radio" >-->
<!--                                <span style="padding-right: 10px">托育</span>-->
<!--                            </div>-->
                            <div class="hang3" v-for="(item,index) in need_teacher">
                                <span class="span1"> 负责员工</span>
                                <select name="teacher[]" v-model="item.tid"  class="in1" required>
                                    <option value="">请选择</option>
                                    <option v-for="(item,index) in teachers" :value="item.user_id">{{item.username}}</option>
                                </select>
                                <img @click="jiaren" style="width: 20px;vertical-align: middle;margin-left: 5px" v-if="index == 0" src="/static/qmsj/img/qietu/+.png">
                                <img @click="jianren" style="width: 20px;vertical-align: middle;margin-left: 5px" v-if="index > 0" src="/static/qmsj/img/tixing.png">
                            </div>
                            <div class=" jialaoshi" style="width: 100%"></div>

                        </div>
                        <div class="h2_r">
                            <div class="hang3">
                                <span class="span1">计次数量</span>
                                <input class="in2" type="number" min="0" name="xiaohao" v-model="xiaohao" required><span class="span3">&nbsp;次</span>
                            </div>
                            <div class="hang3">
                                <span class="span1">上传图片</span>
                                <div id="shangchuan" @click="shanchuan" class="btn btn-success btn-sm">上传</div>
                                <input id="chuanzhao" type="file" name="img"  style="display: none">

                                <img id="imgyl" src="" style="width: 80px;height: 40px" alt="">
                            </div>

                            <div class="h2_r1">
                                <span class="span1">活动介绍</span>
                            </div>
                            <!-- <div class="h2_r2"></div> -->
                            <textarea class="h2_r2" name="jieshao" id="jieshao"  required></textarea>

                            <div style="clear: both"></div>
                            <input type="hidden" name="token" v-model="token">
                            <input class="huodtj" style="display: block" value="添加活动" @click="checkadd" type="button">
                        </div>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </form>


       <div class="zhuti2">

            <div class="huod_t2" style="    border-left: 4px solid #E6BE8A">当前活动</div>
            <!--<div class="huod_t3">-->
                <!--<a href="javascript:void(0)" @click="jump('wqhd')">-->
                    <!--往期活动 <img style="width: 11px;vertical-align: middle" src="/static/qmsj/img/righth.png" alt="">-->
                <!--</a>-->
            <!--</div>-->
            <div style="clear: both"></div>
            <div class='kuang'>
                <div v-for="(item,index) in nowhuodong">
                    <div class="tjkuang2 " style="height: auto">
                        <div class="taaa" :id="'divupdate'+index" style="height: auto">
                            <div class="hang2 clearfloat">
                                <div class="h2_l">
                                    <div class="hang3">
                                        <span class="span3">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span> <span>{{item.start_time}}</span>
                                    </div>
                                    <div class="hang3">
                                        <span class="span1">活动主题</span>
                                        <span>{{item.title}}</span>
                                    </div>
                                    <div class="hang3">
                                        <span class="span1">负责员工</span>
                                        <span v-for="(vv,index2) in item.teach">{{vv.username}}&nbsp;&nbsp;</span>
                                    </div>
                                </div>
                                <div class="h2_r">
<!--                                    <div class="hang3">-->
<!--                                        <span class="span1">活动类型</span>-->
<!--                                        <span v-if="item.system_flag == 'M'">托育活动</span>-->
<!--                                        <span v-if="item.system_flag == 'G'">早教活动</span>-->
<!--                                    </div>-->
                                    <div class="hang3">
                                        <span class="span1">计次数量</span> <span>{{item.xiaohao}}次</span>
                                    </div>
                                    <div class="h2_r1">
                                        <span class="span1">活动介绍</span>
                                    </div>
                                    <div class="h2_r2_2">{{item.jieshao}}</div>
                                </div>
                            </div>
                            <div class="hang3">
                                <span class="span1">已预约</span>
                                <div class="container-fluid">
                                    <div class="row">
                                        <div v-for="(vs,index3) in item.yuyue" class="col-sm-2 marB10">
                                            <span style="padding-right: 10px">{{vs.baobao_name}}</span>
                                            <span @click='qxyy(vs.user_id,item.hd_id)' v-if="vs.tag == 2" class="bt btn-info btn-sm">取消预约</span>
                                            <span  v-if="vs.tag == 1" class="bt btn-success btn-sm">已签到</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tjhdd">
                                <input class=" huodtj2" value="删除" type="button" @click="del(item.hd_id)">
                                <input class="xiugai huodtj2" value="修改" @click="xiugai(index)" type="button">
                            </div>
                        </div>
                        <form action="''" method="post" :id="'formupdate'+index">
                            <div class="tjkuang3" :id="'doupdate'+index" style="display: none">
                                <div class="hang2">
                                    <div class="h2_l">
                                        <div class="hang3">
                                            <span class="span1">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>
                                            <el-date-picker
                                                    v-model="item.start_time"
                                                    value-format="yyyy-mm-dd"
                                                    type="date"
                                                    name="start_time"
                                                    placeholder="选择日期">
                                            </el-date-picker>
                                            <input type="hidden" name="hd" v-model="item.hd_id">
                                        </div>
                                        <div class="hang3">
                                            <span class="span1"> 活动主题</span>
                                            <input class="in1" type="text" v-model="item.title" name="title" required>
                                        </div>
                                        <div class="hang3">
                                            <span class="span1"> 负责老师</span>
                                            <div style="padding-left:10px;width:100%">
                                                <select style="margin-right:5px;margin-bottom:10px" name="teacher[]" v-for="(ve,index3) in item.teach" v-model="ve.user_id" class="in1" required>
                                                    <option value="">请选择</option>
                                                    <option  v-for="(itema,indexa) in teachers" :value="itema.user_id" >{{itema.username}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="h2_r">
                                        <div class="hang3">
                                            <span class="span1"> 活动类型</span>
                                            <input style="margin: 0;vertical-align: middle" v-model="item.system_flag" value="G" name="system_flag" type="radio">
                                            <span style="padding-right: 10px">早教       </span>
                                            <input style="margin: 0;vertical-align: middle" v-model="item.system_flag" value="M" name="system_flag" type="radio" >
                                            <span style="padding-right: 10px">托育</span>
                                        </div>
                                        <div class="hang3">
                                            <span class="span1">消耗课时</span>
                                            <input class="in2" type="text" v-model="item.xiaohao" name="xiaohao" required>
                                            <span class="span3">&nbsp;节</span>
                                        </div>
                                        <div class="h2_r1">
                                            <span class="span1">活动介绍</span>
                                        </div>
                                        <textarea class="h2_r2" name="jieshao" v-model="item.jieshao"  required></textarea>
                                    </div>
                                </div>
                                <input class="huodtj3" value="完成" type="button" @click="querenxiu(index)">
                                <input class="huodtj3" value="取消" @click="quxiaoxiugai(index)" type="button">
                            </div>
                        </form>
                    </div>
                    <div style="width: 100%;height: 12px"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value1:'',  //添加活动时间
                title1:'',  //添加活动标题
                xiaohao:0,    //添加活动消耗课时
                value2:'',
                token: '',
                teachers:[],
                nowhuodong:[],
                need_teacher:[{tid:''}]
            }
        },
        methods: {
            jump: function (e) {
                this.$router.push(e)
            },
            checkadd:function(){    //活动设置添加活动
                let self = this;
                //判断参数
                if(self.value1 ==''){
                    self.$message.error("活动时间必须填写");
                    return;
                }
                if(self.title1 ==''){
                    self.$message.error("活动标题必须填写");
                    return;
                }
//                if(self.xiaohao =='' || self.xiaohao < 0){
//                    self.$message.error("消耗课时必须填写");
//                    return;
//                }
                for(var i=0;i<self.need_teacher.length;i++){
                    var tmp = self.need_teacher[i].tid;
                    if( tmp.length == 0 || tmp == 'undefined'){
                        self.$message.error("负责老师必须填写");
                        return;
                    }
                }
                //验证成功 执行添加
                let formData = new FormData($('#formadd')[0]);

                $.ajax({
                    type: "POST",
                    url: process.env.apiUrl + "saas/activity/add",
                    data: formData,
                    contentType: false,
                    processData: false,
                    dataType : 'json',
                    success: function(data) {
                        if(data.status == 1){
                            self.$message.success("活动添加成功");
                            $('#imgyl').attr('src','');
                            $('#jieshao').val('');
                            self.value1 = '';
                            self.title1 = '';
                            self.xiaohao = 0;
                            self.need_teacher = [{tid:''}];
                            self.showindex();
                        }else{
                            self.$message.error("活动添加失败");
                        }
                    },
                    error: function() {
                        self.$message.error(`异常错误,请稍后重试`)
                    }
                });
            },
            querenxiu:function(index){
                let self = this;
                this.$confirm('是否确认修改此活动?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //判断参数
                    if(self.nowhuodong[index].start_time ==''){
                        self.$message.error("活动时间必须填写");
                        return;
                    }
                    if(self.nowhuodong[index].title ==''){
                        self.$message.error("活动主题必须填写");
                        return;
                    }
//                    if(self.nowhuodong[index].xiaohao ==''){
//                        self.$message.error("消耗课时必须填写");
//                        return;
//                    }
                    for(var i=0;i<self.nowhuodong[index].teach.length;i++){
                        var tmp = self.nowhuodong[index].teach[i].user_id;
                        if( tmp.length == 0 || tmp == ''){
                            self.$message.error("负责老师必须填写");
                            return;
                        }
                    }
                    //执行修改
                    $.ajax({
                        url: process.env.apiUrl + "saas/activity/xiu",
                        type: "post",
                        async: false,
                        data: {
                            'token':self.token,
                            'title':self.nowhuodong[index].title,
                            'start_time':self.nowhuodong[index].start_time,
                            'hd_id':self.nowhuodong[index].hd_id,
                            'system_flag':self.nowhuodong[index].system_flag,
                            'xiaohao':self.nowhuodong[index].xiaohao,
                            'jieshao':self.nowhuodong[index].jieshao,
                            'teacher':self.nowhuodong[index].teach,
                        },
                        success: function (data) {
                            if (data.status == 1) {
                                self.$message.success(data.msg);
                                $('#divupdate'+index).show();
                                $('#doupdate'+index).hide();
                                self.showindex()
                            }else{
                                self.$message.error(data.msg);
                            }
                        }
                    })
                }).catch(() => {
                });
            },
            xiugai:function (index) {
                $('#divupdate'+index).hide();
                $('#doupdate'+index).show();
            },
            quxiaoxiugai:function(index){
                $('#divupdate'+index).show();
                $('#doupdate'+index).hide();
                this.showindex()
            },
            //上传图片直接显示
            shanchuan:function () {
                let self = this;
                $("#chuanzhao").click(); //隐藏了input:file样式后，点击头像就可以本地上传
                $("#chuanzhao").on("change", function () {
                    var objUrl = self.getObjectURL(this.files[0]); //获取图片的路径，该路径不是图片在本地的路径
                    if (objUrl) {
                        $("#imgyl").attr("src", objUrl); //将图片路径存入src中，显示出图片
                    }
                });
            },
            getObjectURL: function (file) {
                var url = null;
                if (window.createObjectURL != undefined) { // basic
                    url = window.createObjectURL(file);
                } else if (window.URL != undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                } else if (window.webkitURL != undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                }
                return url;
            },
            //增加负责老师
            jiaren: function () {
                this.need_teacher.push({'tid':''});
            },
            //减少负责老师
            jianren: function (obj) {
                this.need_teacher.pop();
            },

            del: function (hd_id,) {
                let self = this;
                this.$confirm('是否删除此活动?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $.ajax({
                        url: process.env.apiUrl + "saas/activity/shanchu",
                        type: "post",
                        async: false,
                        data: {"id": hd_id,'token':self.token,},
                        success: function (data) {
                            if (data.status == 1) {
                                self.$message.success(data.msg);
                                self.showindex()
                            }else{
                                self.$message.error(data.msg);
                            }
                        }
                    })
                }).catch(() => {
                });
            },

            qxyy: function (uid, hd_id) {
                let self = this;
                this.$confirm('是否确认该用户取消预约?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $.ajax({
                        url: process.env.apiUrl + "saas/activity/quxiaoyy",
                        type: "post",
                        async: false,
                        data: {"hd_id": hd_id, "user_id": uid,'token':self.token},
                        success: function (e) {
                            if (e.status == 1) {
                                self.$message.success(e.msg);
                                self.showindex();
                            }else{
                                self.$message.error(e.msg);
                            }
                        }
                    })
                }).catch(() => {
                });
            },

            showindex:function(){
                let self = this;
                $.ajax({
                    url: process.env.apiUrl + "saas/activity/hdsz",
                    type: "post",
                    async: false,
                    data: {'token':self.token},
                    success: function (data) {
                        self.nowhuodong = data.data;
                    }
                })
            },
          get_staff(){
            let that = this;
            $.ajax({
              url: process.env.apiUrl + "saas/user/allstaff",
              type: "post",
              async: false,
              data: {'token':that.token},
              success: function (res) {
                that.teachers = res.data;
              }
            })
          }
        },

        mounted: function () {
            var self = this
            self.token = self.$cookies.get("token")
            self.showindex();
            self.get_staff()
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0
    }

    a {
        text-decoration: none;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    em,
    i {
        font-style: normal;
        font-weight: normal;
    }

    img {
        vertical-align: top;
        border: 0;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
        font-weight: 500;
        margin: 0;
        padding: 0;
    }

    * {
        margin: 0;
        padding: 0;
    }

    input, a {
        outline: none;
    }

    .wrap {
        min-width: 320px;
        max-width: 640px;
        margin: 0 auto;
    }

    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    /*伪类清除浮动*/
    .fix {
        *zoom: 1;
    }

    .fix:after {
        display: block;
        content: "clear";
        height: 0;
        clear: both;
        overflow: hidden;
        visibility: hidden;
    }

    body {
        width: 100%;
        background: #f6f6f6;
        font-family: "微软雅黑";
        font-size: 14px;
    }

    /*导航部分*/

    .yg_nav {
        width: 93%;
        margin: 0 auto;
        height: 60px;
    }

    .yg-l {
        width: 50%;
        float: left
    }

    .yg-r {
        width: 50%;
        float: left
    }

    .yg_nav1_1 {
        display: block;
        float: left;
        width: 100%;
        font-size: 18px;
        height: 44px;
        line-height: 44px;

    }

    .qiehu {
        float: left;
        width: 245px;
        height: 40px;
        margin-top: 10px;
    }

    .sy {
        border-left: 1px solid #7c73bf;
        border-right: 1px solid #7c73bf;
        border-top: 1px solid #7c73bf;
        float: left;
        width: 94px;
        height: 39px;
        line-height: 39px;
        background: #7c73bf;
        text-align: center;
        border-radius: 8px 8px 0 0;
    }

    .sy > a {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: white;
    }

    .hd {
        border-left: 1px solid #7c73bf;
        border-right: 1px solid #7c73bf;
        border-top: 1px solid #7c73bf;
        float: left;
        width: 129px;
        height: 39px;
        line-height: 39px;
        margin-left: 15px;
        text-align: center;
        border-radius: 8px 8px 0 0;
        background: #ececff;
    }

    .hd > a {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #a4a0d6;
    }

    .suo {
        display: block;
        width: 100%;
        height: 100%;

    }

    .suoin {
        width: 238px;
        height: 33px;
        border: 1px solid #dbdbdb;
        border-radius: 5px;
    }

    .suosoutu {
        width: 35px;
        vertical-align: middle;
        padding-bottom: 2px;
    }

    .zhuti {
        width: 93%;
        margin: 26px auto 0;
    }

    /*
    .zhu_l{
        float: left;
        width: 100%;
        !*height: 560px;*!
      !*  border-right: 1px solid #dbdbdb;*!
    }
    */

    .huod_t {
        width: 100%;
        border-left: 4px solid #E6BE8A;
        height: 25px;
        line-height: 25px;
        padding-left: 12px;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .tjkuang {
        width: 100%;
        /*height:200px;*/
        padding-bottom: 10px;
        border: 1px solid #dbdbdb;
        box-shadow: 1px 1px 2px 2px #dbdbdb;
        font-size: 14px;
    }

    .hang1 {
        width: 100%;
        height: 24px;
        margin-top: 18px;
        font-size: 14px;

    }

    .in1 {
        height: 24px;
        width: 100px;
        font-size: 14px;
    }

    .span1 {
        padding-left: 16px;
        padding-right: 11px;
    }

    .span2 {
        padding-left: 157px;
        padding-right: 11px;
    }

    .in2 {
        height: 24px;
        width: 59px;
        font-size: 14px;
    }

    .hang2 {
        width: 100%;
        margin-top: 11px;
    }

    .h2_l {
        width: 30%;
        float: left;
    }

    .h2_r {
        width: 70%;
        float: right;
    }

    .hang3 {
        width: 100%;
        margin-bottom: 11px;
    }

    .h2_r1 {
        float: left;
        /*  width: 9.5%;*/
        height: auto;

        /*background: greenyellow;*/
    }

    .h2_r2 {
        float: left;
        width: 88%;
        height: 72px;
        border: 1px solid #dbdbdb;
    }

    .tjhdd {
        width: 100%;
        height: 76px;
        float: left;

    }

    .huodtj {
        display: block;
        width: 132px;
        height: 32px;
        margin: 28px auto 0;
        background: #E6BE8A;
        color: white;
        font-size: 12px;
        line-height: 32px;
        text-align: center;
        border-radius: 16px;
        border: none;
        box-shadow: 1px 1px 4px #999;
    }

    .zhuti2 {
        width: 93%;
        margin: 43px auto 0;
    }

    .huod_t2 {
        width: 40%;
        float: left;
        border-left: 4px solid #E6BE8A;
        height: 25px;
        line-height: 25px;
        padding-left: 12px;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .huod_t3 {
        width: 132px;
        float: right;
        border: 2px solid #fed9b9;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        border-radius: 16px;
        text-align: center;
    }

    .youjiant {
        width: 24px;
        height: 16px;
        margin-top: 3px;
    }

    .kuang {
        width: 100%;
        margin: 0 auto 0;

    }

    .span3 {
        padding-left: 16px;
        padding-right: 11px;
    }

    .h2_r2_2 {
        float: left;
        width: 88%;
        height: 72px;
        /*  border: 1px solid #dbdbdb;*/
    }

    .huodtj2 {
        display: block;
        width: 132px;
        height: 32px;
        margin: 28px 20px 0 auto;
        float: right;
        background: #E6BE8A;
        color: white;
        line-height: 32px;
        text-align: center;
        border-radius: 16px;
        border: none;
        box-shadow: 1px 1px 4px #999;
    }

    .huod_t3 > a {
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: #E6BE8A;
    }

    .tjkuang2 {
        width: 100%;
        height: 200px;
        overflow: hidden;
        transition: 1s linear;
        border: 1px solid #dbdbdb;
        box-shadow: 1px 1px 2px 2px #dbdbdb;
        font-size: 14px;
    }

    .tjkuang3 {
        width: 100%;
        height: 200px;
        overflow: hidden;
        transition: 1s linear;
        /*  border: 1px solid #dbdbdb;*/
        /* box-shadow: 1px 1px 2px 2px #dbdbdb;*/
        font-size: 14px;
    }

    .huodtj3 {
        display: block;
        width: 70px;
        height: 31px;
        margin: 28px 20px 0 auto;
        float: right;
        background: #E6BE8A;
        color: white;
        line-height: 31px;
        text-align: center;
        border-radius: 5px;
    }

    .taaa {
        height: 200px;
        width: 100%;
        overflow: hidden;
        transition: 1s linear;
    }

    .huod_t {
        width: 100%;
        border-left: 4px solid #E6BE8A;
        height: 25px;
        line-height: 25px;
        padding-left: 12px;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .fix:after {
        display: block;
        content: "clear";
        height: 0;
        clear: both;
        overflow: hidden;
        visibility: hidden;
    }

    .clearfloat:after {
        display: block;
        clear: both;
        content: "";
        visibility: hidden;
        height: 0
    }

    .clearfloat {
        zoom: 1
    }

    .marB10 {
        margin-bottom: 10px;
    }
	.bt{
		padding:2px 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/huodong/hdshezhi.vue